import Api from './Api';

class VersaoOrigemApi extends Api {
    async versaoOrigem() {
        let versaoOrigem = await this.fetch(this.configuracao.urlVersaoOrigem);
        return versaoOrigem;
    }
}

export default VersaoOrigemApi;
